import { type PropsWithChildren } from 'react'
import {
  Drawer as DrawerDefault,
  type DrawerProps as DrawerDefaultProps,
} from 'antd'
import { Flex } from '@vtex/admin-ui'

import * as styles from './Drawer.styles'

type DrawerProps = {
  title: React.ReactNode
  footer: React.ReactNode
  isOpen: boolean
  onClose: () => void
  width?: `${number}px` | `${number}%`
} & DrawerDefaultProps

export const Drawer = ({
  title,
  children,
  footer,
  isOpen,
  onClose,
  width = '400px',
  ...props
}: PropsWithChildren<DrawerProps>) => (
  <DrawerDefault
    className={styles.wrapper}
    closeIcon={null}
    title={title}
    onClose={onClose}
    open={isOpen}
    width={width}
    footer={
      <Flex direction="row" justify="flex-end" className={styles.footer}>
        {footer}
      </Flex>
    }
    {...props}
  >
    {children}
  </DrawerDefault>
)
